












import { Component, Vue } from 'vue-property-decorator';
import { setLanguage } from '@/assets/lang/I18n';
import { applyDocumentLanguage } from '@/services/Setupi18n';
@Component({})
export default class LoadingView extends Vue {
  public mounted() {
    const lang: string = !!this.$route.query.lang !== false ? this.$route.query.lang.toString() : '';
    this.$root.$i18n.locale = setLanguage(lang);
    applyDocumentLanguage();
  }
}
